<template>
  <div class="statistics">
    <div class="toolbar">
      <h2>
        <em></em>
        <span>{{$t("stats.title")}}</span>
      </h2>
    </div>
    <section class="chart-container">
      <el-select v-model="apikey" placeholder>
        <el-option
          v-for="item in projects"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select v-model="period" placeholder>
        <el-option
          v-for="item in periods"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select v-model="network" placeholder>
        <el-option
          v-for="item in networks"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-row>
        <!-- Total Method Calls -->
        <el-col :span="23" :empty-text="$t('common.noData')" class="comCont clumW">
          <div id="chartLine" style="width:100%; height:400px;"></div>
        </el-col>
        <!-- Project method calls usage -->
        <el-col :empty-text="$t('common.noData')" class="comCont clum">
          <div id="chartPie" style="width:100%; height:400px;"></div>
        </el-col>
        <!-- Top method calls -->
        <el-col class="comCont clum">
          <div id="chartBar" style="width:100%; height:400px;"></div>
        </el-col>
        <!-- Calls by Time of Day -->
        <el-col class="comCont clum">
          <div id="chartHeatmap" style="width:100%; height:400px;"></div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import echarts from "echarts";
import api from "../../api/api";
import {
  reqAnalyticTs,
  reqAnalyticTopn,
  resCode
} from "../../../server/common/data";
var moment = require("moment");

export default {
  data() {
    return {
      projects: [
        {
          value: "",
          label: this.$t("stats.allProjects")
        }
      ],
      periods: [
        {
          value: "24h",
          label: this.$t("stats.last24h")
        },
        {
          value: "7d",
          label: this.$t("stats.last7d")
        },
        {
          value: "30d",
          label: this.$t("stats.last30d")
        }
      ],
      networks: [
        {
          value: "mainnet",
          label: "MAINNET"
        },
        {
          value: "testnet",
          label: "TESTNET"
        }
      ],
      uid: "",
      isAdmin: false,
      apikey: "",
      period: sessionStorage.getItem("statsPeriod") || "30d",
      network: sessionStorage.getItem("statsNetwork") || "mainnet",
      tzofs: new Date().getTimezoneOffset(),
      chartLine: null,
      chartPie: null,
      chartBar: null,
      chartHeatmap: null,
      topn: 10
    };
  },

  methods: {
    getProjects(cb) {
      api
        .getProjects({})
        .then(res => {
          if (res.data.CODE === resCode.SUCCESS) {
            for (let project of res.data.DATA) {
              this.projects.push({
                value: project["apikey"],
                label: project["name"]
              });
            }
            cb();
          }
        })
        .catch(err => {
          console.error("get project error: " + err);
        });
    },
    completeTsData(data, slice) {
      let result = [];
      for (
        let i = 0, ts = data[0]["k"], end = data[data.length - 1]["k"];
        ts <= end;
        ts += slice
      ) {
        if (ts === data[i]["k"]) {
          result.push({ k: ts, v: data[i]["v"] });
          i++;
        } else {
          result.push({ k: ts, v: 0 });
        }
      }
      return result;
    },
    get10Ceil(value) {
      if (value <= 10) {
        return 10;
      } else {
        let vs = value.toString();
        let pow = vs.length - 1;
        let q = parseInt(vs[0]), r = parseInt(vs.substring(1));
        if (r) q += 1;
        return q * Math.pow(10, pow);
      }
    },
    drawLineChart(time, value) {
      this.chartLine = echarts.init(
        document.getElementById("chartLine"),
        "light"
      );
      this.chartLine.setOption({
        title: {
          text: this.$t("stats.totalMethodCalls")
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          //   data: [""]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: time
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            symbol: "diamond",
            symbolSize: 15,
            data: value,
            type: "line"
          }
        ]
      });
    },
    drawPieChart(name, value) {
      this.chartPie = echarts.init(
        document.getElementById("chartPie"),
        "light"
      );
      this.chartPie.setOption({
        title: {
          text: this.$t("stats.projectMethodCalls")
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "right",
          data: name
        },
        series: [
          {
            name: "project",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: value
          }
        ]
      });
    },
    drawBarChart(name, value) {
      this.chartBar = echarts.init(document.getElementById("chartBar"));
      this.chartBar.setOption({
        title: {
          text: this.$t("stats.topnMethodCalls") + "TOP" + this.topn
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: [this.$t("stats.topnMethodCallsSummary")]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: "category",
          data: name
        },
        series: [
          {
            // name: this.$t("stats.topnMethodCallsSummary"),
            type: "bar",
            data: value,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              }
            }
          }
        ]
      });
    },
    drawHeatmap(today, mapData) {
      this.chartHeatmap = echarts.init(
        document.getElementById("chartHeatmap"),
        "light"
      );
      const hours = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ];
      const daysArray = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
      const days = [];
      const data = [];
      let maxValue = 10; // min scale
      for (let i = 0; i < 7; i++) {
        let dayi = (today + i + 1) % 7;
        days.push(daysArray[dayi]);
        let datai = mapData[dayi];
        for (let j = 0; j < datai.length; j++) {
          datai[j][1] = i;
          if (datai[j][2] === 0) {
            datai[j][2] = "-";
          } else {
            maxValue = Math.max(maxValue, datai[j][2]);
          }
          data.push(datai[j]);
        }
      }
      this.chartHeatmap.setOption({
        title: {
          text: this.$t("stats.chartHeatmap")
        },
        tooltip: {
          position: "top"
        },
        animation: false,
        grid: {
          height: "50%",
          y: "10%"
        },
        xAxis: {
          type: "category",
          data: hours,
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: "category",
          data: days,
          splitArea: {
            show: true
          }
        },
        visualMap: {
          min: 0,
          max: this.get10Ceil(maxValue),
          calculable: true,
          orient: "horizontal",
          left: "center",
          bottom: "15%"
        },
        series: [
          {
            name: "CALLS",
            type: "heatmap",
            data: data
          }
        ]
      });
    },

    drawCharts() {
      // Total Method Calls
      let para = new reqAnalyticTs(
        this.period,
        this.uid,
        this.apikey,
        this.network,
        this.tzofs
      );
      api
        .timeSeries(para)
        .then(res => {
          let time = [];
          let value = [];
          if (res.data.CODE === resCode.SUCCESS) {
            let slice = 60 * 60 * 1000;
            let formatHour = true;
            if (this.period !== "24h") {
              slice = slice * 24;
              formatHour = false;
            }
            let data = this.completeTsData(res.data.DATA, slice);
            let m, t;
            for (let i = 0; i < data.length; i++) {
              m = moment(data[i].k);
              if (formatHour) {
                t = m.format("h A");
              } else {
                t = m.format("M-D");
              }
              time.push(t);
              value.push(data[i].v);
            }
          }
          this.drawLineChart(time, value);
        })
        .catch(err => {
          console.error("get data error: " + err);
        });
      // drawPieChart
      para = new reqAnalyticTopn(
        "project",
        10,
        this.period,
        this.uid,
        null,
        this.network,
        this.tzofs
      );
      api
        .topn(para)
        .then(res => {
          let name = [],
            value = [],
            showName;
          if (res.data.CODE === resCode.SUCCESS) {
            for (let data of res.data.DATA) {
              if (data["o"] && !this.uid) {
                showName = data["o"] + "' " + data["k"];
              } else {
                showName = data["k"];
              }
              name.push(showName);
              value.push({ value: data["v"], name: showName });
            }
          }
          this.drawPieChart(name, value);
        })
        .catch(err => {
          console.error("get data error: " + err);
        });
      // drawBarChart
      para = new reqAnalyticTopn(
        "method",
        10,
        this.period,
        this.uid,
        this.apikey,
        this.network,
        this.tzofs
      );
      api
        .topn(para)
        .then(res => {
          let name = [];
          let value = [];
          if (res.data.CODE === resCode.SUCCESS) {
            for (let data of res.data.DATA) {
              name.unshift(data["k"]);
              value.unshift(data["v"]);
            }
          }
          this.drawBarChart(name, value);
        })
        .catch(err => {
          console.error("get data error: " + err);
        });
      // Calls by Time of Day
      para = new reqAnalyticTs(
        "168h",
        this.uid,
        this.apikey,
        this.network,
        this.tzofs
      );
      api
        .timeSeries(para)
        .then(res => {
          let mapData = [];
          if (res.data.CODE === resCode.SUCCESS) {
            // daily data array
            for (let i = 0; i < 7; i++) {
              mapData[i] = [];
            }
            let data = this.completeTsData(res.data.DATA, 60 * 60 * 1000);
            let m, day;
            for (let i = 0; i < data.length; i++) {
              m = moment(data[i].k);
              day = m.day();
              mapData[day].push(new Array(m.hour(), day, data[i].v));
            }
          }
          this.drawHeatmap(moment().day(), mapData);
        })
        .catch(err => {
          console.error("get data error: " + err);
        });
    }
  },

  mounted: function() {
    this.isAdmin = (sessionStorage.getItem("role") === "admin");
    if (this.isAdmin) {
      let username = this.$route.params.username;
      if (username) { // admin specify one user
        this.uid = this.$route.params.uid;
        if (this.$route.params.apikey) {
          this.apikey = this.$route.params.apikey;
        }
        this.projects = [
          {
            value: "",
            label: username + "' " + this.$t("stats.allProjects")
          }
        ];
        api
          .search({
            key: username
          })
          .then(res => {
            if (res.data.CODE === resCode.SUCCESS) {
              res.data.DATA.projects.forEach(item => {
                this.projects.push({
                  value: item["apikey"],
                  label: username + "' " + item["name"]
                });
              });
            }
          })
          .catch(() => {});
      } else {
        this.drawCharts(); // admin whole site
      }
    } else { // normal user
      this.getProjects(()=>{
        if (this.projects.length === 1) { // should init charts when no project
          this.drawCharts();
        }
      });
    }
  },
  updated: function() {
    this.drawCharts();
    sessionStorage.setItem("statsPeriod", this.period);
    sessionStorage.setItem("statsNetwork", this.network);
  }
};
</script>

<style lang="scss">
.chart-container {
  // width: 100%;
  text-align: left;
  font-size: 18px;
  margin: 50px 0 0 26px;
  .el-select {
    margin: 10px 40px 0 0;
  }
  .comCont {
    margin-top: 40px;
    margin-bottom: 40px;
    padding: 20px;
    // background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
  }
}
@media screen and (min-width: 1025px) {
  .comCont {
    margin: 40px 1% 40px 0!important;
  }
  .clumW{
    width: 99%;
  }
  .clum{
    width: 32.33%;
  }
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
  .comCont {
    margin: 40px 3% 40px 0!important;
  }
  .clum{
    width: 47%;
  }
}

@media screen and (min-width: 320px) and (max-width: 1366px) {
  .clum{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// Statistics.vue?118b9ee3